import type { ReactNode } from 'react'

import type { DesignSystemContextValue } from './ds-context'
import { DesignSystemContextProvider } from './ds-context'

/**
 * Sensible CZ-region defaults so unit tests and stories that don't care about
 * the runtime context can still render formatting components. Override any
 * field by passing `value`.
 */
const defaultTestValue: DesignSystemContextValue = {
  currencyCode: 'CZK',
  callingCodes: ['+420', '+421'],
  formattedOptions: {
    presets: {
      // minimal shapes; tests should override if they exercise these inputs
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      zipCode: {} as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      personalId: {} as any,
      date: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        cs: {} as any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pl: {} as any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        en: {} as any,
      },
      money: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        cs: { delimiter: ' ' } as any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pl: { delimiter: ' ' } as any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        en: { delimiter: ',' } as any,
      },
    },
    currency: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cs: { decimalSeparator: ',', thousandSeparator: ' ' } as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      pl: { decimalSeparator: ',', thousandSeparator: ' ' } as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      en: { decimalSeparator: '.', thousandSeparator: ',' } as any,
    },
  },
  supportEmail: 'support@example.test',
  support: {
    email: 'support@example.test',
    phoneNumber: '+420 000 000 000',
    hoursFrom: 9,
    hoursTo: 18,
    days: 'mo-fr',
  },
}

type Props = {
  children: ReactNode
  value?: Partial<DesignSystemContextValue>
}

export const TestDesignSystemContextProvider = ({
  children,
  value,
}: Props) => (
  <DesignSystemContextProvider value={{ ...defaultTestValue, ...value }}>
    {children}
  </DesignSystemContextProvider>
)
